"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inlineReadOnlyDiv = require("./inlineReadOnlyDiv");

var _inlineReadOnlyDiv2 = _interopRequireDefault(_inlineReadOnlyDiv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _inlineReadOnlyDiv2.default;